import React from 'react';

const Moderation: React.FC = () => {
  return (
    <section id="moderation" className="content-section">
      <div className="flex justify-between items-center mb-6 header-border pb-4">
        <h2 className="text-xl font-semibold text-white">moderation</h2>
      </div>
      
      <div className="flex flex-col items-center justify-center text-center p-12 paint-card min-h-[400px]">
        <i className="fa-solid fa-shield-halved fa-6x mb-6 text-white opacity-70"></i>
        <h3 className="text-2xl text-white mb-4">moderation tools coming soon...</h3>
        <p className="text-lg text-gray-400 mb-2">dork is building ur security system.</p>
        <p className="text-sm text-gray-500 max-w-md">
          soon u'll have auto-mod, word filters, spam protection, and more. 
          keep ur chat clean and ur community safe.
        </p>
        <div className="mt-6 text-xs text-gray-600">
          <i className="fa-solid fa-shield mr-2"></i>
          protected by the dork team
        </div>
      </div>
    </section>
  );
};

export default Moderation;